import { useTranslation } from 'react-i18next';
import noNewMessagesImage from '../assets/no-new-messages.png';
import { defaultColors } from '../../../../styles/style-guide';
import { useAppSelector } from '../../../../hooks/hooksRedux';
import { RootState } from '../../../../store';

const NoNewMessages: React.FC = () => {
  const { colors } = useAppSelector((state: RootState) => state.styleGuide.data);
  const { t } = useTranslation();
  const primaryColor = colors.primary || defaultColors.primary;
  return (
    <div className="flex flex-1 flex-col items-center justify-center rounded-lg border-[2px] border-solid border-[#E1E9EF] bg-white p-8">
      <img src={noNewMessagesImage} className="mb-4" alt="No messages" />
      <h1 style={{color: primaryColor}} className="text-xl font-bold">{t('labels.lblSelectChat')}</h1>
    </div>
  );
}

export { NoNewMessages };
